import React, { useState } from "react";
import { Button, Input, InputGroup, Badge } from "reactstrap";
import { CarDetails, Selector, Selectors } from "./types";

interface ValueSelectorProps {
  fieldName: keyof CarDetails;
  selector: Selector;
  handleSelectorChange: (
    fieldName: keyof Selectors,
    updatedSelector: Partial<Selector>,
  ) => void;
}

const ValueSelector: React.FC<ValueSelectorProps> = ({
  fieldName,
  selector,
  handleSelectorChange,
}) => {
  const [open, setOpen] = useState(Boolean(selector.prefix || selector.suffix));

  const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleSelectorChange(fieldName, {
      value: event.target.value,
    });
  };

  const handlePrefixChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleSelectorChange(fieldName, {
      prefix: event.target.value,
    });
  };

  const handleSuffixChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleSelectorChange(fieldName, {
      suffix: event.target.value,
    });
  };

  return (
    <div className="selector-container">
      <div className="main-selector mb-1">
        <InputGroup size="sm">
          <Input
            type="text"
            value={selector.value || ""}
            onChange={handleValueChange}
            placeholder="Sélecteur"
            className="selector-input"
          />
          <Button
            onClick={() => setOpen(!open)}
            size="sm"
            color={open ? "primary" : "light"}
            className="toggle-button"
            title={open ? "Masquer options" : "Afficher options"}
            style={{
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
              width: "36px",
            }}
          >
            {open ? "−" : "+"}
          </Button>
        </InputGroup>
      </div>

      {open && (
        <div
          className="additional-options p-2 mb-2 border rounded"
          style={{ backgroundColor: "#f8f9fa" }}
        >
          <div className="mb-2">
            <Badge color="secondary" className="mb-1" pill>
              Préfixe
            </Badge>
            <Input
              type="text"
              value={selector.prefix || ""}
              onChange={handlePrefixChange}
              placeholder="Texte à ajouter avant la valeur"
              bsSize="sm"
              className="mt-1"
            />
          </div>

          <div>
            <Badge color="secondary" className="mb-1" pill>
              Suffixe
            </Badge>
            <Input
              type="text"
              value={selector.suffix || ""}
              onChange={handleSuffixChange}
              placeholder="Texte à ajouter après la valeur"
              bsSize="sm"
              className="mt-1"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ValueSelector;
